import AssetsServices from "../../services/assetsServices";
import {
  attemptSetFolder,
  setFolderSuccess,
  attemptGetAssets,
  getAssetsSuccess,
  setActiveFolderId,
  attemptEditFolder,
  editFolderSuccess,
  attemptRemoveFolder,
  removeFolderSuccess,
} from "../actions/assetsActions";

const assetsServices = new AssetsServices();

const getInitialActiveFolderId = (folders) => {
  if (!folders.length) return null;
  const first = folders[0];
  if (first.assetCount > 0) return first.id;
  if (first.children?.length > 0) return first.children[0].id;
  return first.id;
};

export const getFolders = async (
  showInModal,
  sortQuery,
  currentActiveFolderId = null,
  search,
) => {
  const foldersRes = await assetsServices.getFolders();
  const folders = foldersRes.data.data;
  if (showInModal && !currentActiveFolderId) return { folders, activeFolderId: null, assets: null };
  const activeFolderId = showInModal
    ? currentActiveFolderId
    : window.location.pathname.split("/").pop() === "assets"
      ? getInitialActiveFolderId(folders)
      : Number(window.location.pathname.split("/").pop());
  const result = { folders, activeFolderId, assets: null };
  if (search) {
    const assetRes = await assetsServices.getFiles(null, sortQuery, search);
    result.assets = assetRes.data.data;
    const matchingFolderIds = new Set(result.assets.map((a) => a.folderId));
    result.folders = folders
      .map((folder) => {
        const hasMatch = matchingFolderIds.has(folder.id);
        const filteredChildren = (folder.children || []).filter((child) =>
          matchingFolderIds.has(child.id),
        );
        if (hasMatch || filteredChildren.length) {
          return { ...folder, children: filteredChildren };
        }
        return null;
      })
      .filter(Boolean);
  } else if (activeFolderId) {
    const assetRes = await assetsServices.getFiles(activeFolderId, sortQuery);
    result.assets = assetRes.data.data;
  }
  return result;
};

export const setFolder = async (name, dispatch, navigate, props, parentId) => {
  try {
    dispatch(attemptSetFolder());
    const response = await assetsServices.setFolder(name, parentId);
    const res = response.data;
    if (!parentId && !props.showInModal) {
      navigate(`/assets/${res.id}`);
    }
    dispatch(setFolderSuccess(res));
  } catch (e) {}
};

export const editFolder = async ({ folderId, folderName }, list, dispatch, setIndex) => {
  try {
    dispatch(attemptEditFolder());
    await assetsServices.editFolder({ folderId, folderName });
    const updatedList = list.map((folder) => {
      if (folderId === folder.id) {
        return { ...folder, name: folderName };
      }
      if (folder.children) {
        return {
          ...folder,
          children: folder.children.map((child) =>
            child.id === folderId ? { ...child, name: folderName } : child,
          ),
        };
      }
      return folder;
    });
    setIndex(0);
    dispatch(editFolderSuccess(updatedList));
  } catch (e) {
    console.error(e);
  }
};

export const removeFolder = async (id, dispatch, navigate, folder) => {
  try {
    dispatch(attemptRemoveFolder());
    await assetsServices.removeFolder(id);
    const isRootFolder = folder.list.some((f) => f.id === id);
    let filteredList;
    if (isRootFolder) {
      filteredList = folder.list.filter((f) => f.id !== id);
    } else {
      filteredList = folder.list.map((f) =>
        f.children ? { ...f, children: f.children.filter((child) => child.id !== id) } : f,
      );
    }
    if (folder.activeFolderId === id) {
      navigate("/assets");
      dispatch(removeFolderSuccess({ id: null, filteredList }));
    } else {
      navigate(`/assets/${folder.activeFolderId}`);
      dispatch(removeFolderSuccess({ id: folder.activeFolderId, filteredList }));
    }
  } catch (e) {
    console.error(e);
  }
};

export const setFiles = async (data, i, onUploadProgress) => {
  try {
    return await assetsServices.setFiles(data, i, onUploadProgress);
  } catch (e) {
    console.error(e);
  }
};

export const removeFile = async (IDs, state) => {
  try {
    await Promise.all(IDs.map((id) => assetsServices.removeFile(id)));
    const removeSet = new Set(IDs);
    return state.folder.file.list.filter((item) => !removeSet.has(item.id));
  } catch (e) {}
};

export const getFiles = async (
  id,
  dispatch,
  navigate,
  setShowSpinner,
  showInModal,
  sort,
  search,
) => {
  try {
    if (id) {
      dispatch(attemptGetAssets());
      setShowSpinner(true);
      const assetsRes = await assetsServices.getFiles(id, sort, search);
      const assets = assetsRes.data.data;
      !showInModal && navigate(`/assets/${id}`);
      dispatch(getAssetsSuccess({ assets, id }));
      setShowSpinner(false);
    } else {
      !showInModal && navigate(`/assets`);
      dispatch(setActiveFolderId(id));
    }
  } catch (e) {
    console.error(e);
  }
};
